(function () {
  function getElementId(Q) {
    return document.querySelector(`#${Q}`);
  }
  if (getElementId('sug_wraper') === null) {
    return;
  }
  const suggHistoryTail = '<li class="hhy-suggoperate"><a href="javascript:window.sug.clear();">清除历史</a><a href="javascript:void(0);" class="hhy-sugclose" onclick="window.sug.close();">关闭</a></li>';
  const suggTail = '<li class="hhy-suggoperate"><a href="javascript:void(0);" class="hhy-sugclose" onclick="window.sug.close();">关闭</a></li>';
  const info = {
    inputId: 'keyword',
    sugNum: 10,
    sugScriptId: 'sug',
    checkInterval: 500,
    showHistoryWord: false,
  };
  const sugStatus = {
    focus: false,
    lastKw: '',
    cache: {},
    isRequesting: false,
    currentSugKw: '',
    isClose: 0,
  };

  window.sug = {};
  window.sogou = window.sogou || {};
  window.sogou.sug = function (res) {
    if (!res) return false;
    const Q = [res.q, res.s.map(item => item.q)];
    if (Q[0] !== '') {
      sugStatus.cache[Q[0]] = Q;
    }
    paintResult(Q);
    sugStatus.isRequesting = false;
  };

  function escapeForSpecialChars(input) {
    if (input) {
      return input.replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }
    return '';
  }

  function unescapeForSpecialChars(input) {
    if (input) {
      return input.replace('&amp;', '&').replace('&lt;', '<')
        .replace('&gt;', '>')
        .replace('&quot;', '"');
    }
    return '';
  }

  function strip(Q) {
    return Q.replace(/(^[\s\t\xa0\u3000]+)|([\u3000\xa0\s\t]+x24)/g, '');
  }

  function createWrapper() {
    sugStatus.lastKw = getElementId(info.inputId).value;
    sugStatus.focus = false;
    addListener();
  }

  function ajaj(S) {
    const cache = sugCache(S);
    if (cache) {
      window.sogou.sug(cache);
      return;
    }
    const url = `https://sor.html5.qq.com/api/getsug?key=${S}&sugtime=${Date.now()}&s=1&pid=v.sogou.com&m=window.sogou.sug&cb=window.sogou.sug&source=wapsearch`;
    let sugdiv = getElementId(info.sugScriptId);
    if (sugdiv) {
      document.body.removeChild(sugdiv);
    }
    sugdiv = document.createElement('script');
    sugdiv.id = info.sugScriptId;
    sugdiv.src = url;
    document.body.appendChild(sugdiv);
  }

  function paintResult(W) {
    const sugdata = getElementId('sug_wraper');
    if (!W) {
      sugStatus.currentSugKw = '';
      sugdata.innerHTML = '';
      return;
    }
    if (Object.prototype.toString.call(W) !== '[object Array]') {
      return;
    }
    if (W[1].length === 0) {
      sugStatus.currentSugKw = '';
      displaynone();
      return;
    }
    if (sugStatus.currentSugKw === W[1]) {
      display();
      return;
    }
    sugdata.innerHTML = '';
    const tmp = [];
    tmp.push('<ul>');
    for (let T = 0; T < W[1].length && T < info.sugNum; T += 1) {
      const Q = W[1][T];
      if (W[0] === 'sugg_top_word') {
        tmp.push(`<li class="hhy-sugglist" onclick="window.sug.select('${encodeURIComponent(escapeForSpecialChars(Q))}');"><p><em>${
          T + 1
        }</em><strong>${Q}</strong></p><a href="javascript:void(0);" class="hhy-suggarr"><span></span></a></li>`);
      } else {
        let text = Q;
        const wordIndex = Q.indexOf(W[0]);
        if (wordIndex > -1) {
          text = `${Q.substring(wordIndex, wordIndex + W[0].length)}<strong>${Q.substring(wordIndex + W[0].length)}</strong>`;
        } else {
          text = `<strong>${Q}</strong>`;
        }
        tmp.push(`<li class="hhy-sugglist" onclick="window.sug.select('${encodeURIComponent(escapeForSpecialChars(Q))}');"><p>${text}</p><a href="javascript:void(0);" class="hhy-suggarr"><span></span></a></li>`);
      }
    }
    if (W[0] === 'sugg_history_word') {
      tmp.push(suggHistoryTail);
    } else {
      tmp.push(suggTail);
    }
    tmp.push('</ul>');
    sugdata.innerHTML = tmp.join('');
    [, sugStatus.currentSugKw] = W;
    display();
  }
  const focusHandle = function () {
    sugStatus.focus = true;
    setTimeout(L, 10);
  };
  const blurHandle = function () {
    sugStatus.focus = false;
  };

  function addListener() {
    getElementId(info.inputId).setAttribute('autocomplete', 'off');
    getElementId(info.inputId).addEventListener('focus', focusHandle, false);
    getElementId(info.inputId).addEventListener('blur', blurHandle, false);
  }

  function displaynone() {
    getElementId('sug_wraper').style.display = 'none';
  }

  function display() {
    getElementId('sug_wraper').style.display = 'block';
  }

  function L() {
    if (sugStatus.focus) {
      let Q = getElementId(info.inputId).value;
      Q = Q.toLowerCase();
      Q = strip(Q);
      if (Q === '') {
        document.getElementsByClassName('hhy-del')[0].style.display = 'none';
        if (!sugStatus.showHistoryWord) {
          showTopWord();
        }
      } else {
        const R = sugStatus.cache[Q];
        document.getElementsByClassName('hhy-del')[0].style.display = 'block';
        if (R) {
          paintResult(R);
        } else {
          if (!sugStatus.isRequesting) {
            sugStatus.isRequesting = true;
            ajaj(encodeURIComponent(Q));
          }
        }
      }
      setTimeout(L, info.checkInterval);
    }
  }

  function sugCache(R) {
    Object.keys(sugStatus.cache).forEach((Q) => {
      if (R.indexOf(Q) >= 0 && sugStatus.cache[Q][1].length === 0) {
        return {
          q: R,
          s: [],
        };
      }
    });

    return null;
  }

  function search(R) {
    const form = document.forms[0];
    sugStatus.focus = false;
    form.keyword.value = decodeURIComponent(unescapeForSpecialChars(R));
    displaynone();
    setTimeout(() => {
      form.submit();
    }, 500);
  }
  createWrapper();
  window.sug.close = function () {
    displaynone();
    sugStatus.showHistoryWord = false;
  };
  window.sug.select = search;
  window.sug.clear = clearSearchRecord;

  function replacequote(str) {
    if (str !== null) {
      return str.replace(/\\'/g, '\\\'');
    }
    return '';
  }

  function showTopWord() {
    const cache = sugCache('sugg_top_word');
    if (cache) {
      window.sogou.sug(cache);
      return;
    }
    if (
      window.localStorage
      && window.localStorage.getItem('v_search_record')
      && window.localStorage.getItem('v_search_record').length > 0
    ) {
      let searchRecords = window.localStorage.getItem('v_search_record');
      if (searchRecords && searchRecords.length > 0) {
        searchRecords = JSON.parse(searchRecords);
        const tmp = [];
        tmp.push('<ul>');
        for (let t = 0; t < searchRecords.length; t += 1) {
          const text = searchRecords[t];
          if (text === '') {
            continue;
          }
          tmp.push(`<li class="hhy-sugglist" onclick="window.sug.select('${replacequote(escapeForSpecialChars(encodeURIComponent(text)))}');"><p>${escapeForSpecialChars(text)}</p><a href="javascript:void(0);" class="hhy-suggarr"><span></span></a></li>`);
        }
        tmp.push(suggHistoryTail);
        tmp.push('<ul>');
        const sugdata = getElementId('sug_wraper');
        sugdata.innerHTML = tmp.join('');
        display();
      }
    } else {
      const url = '/frags/suggestion_top_word.html';
      let sugdiv = getElementId(info.sugScriptId);
      if (sugdiv) {
        document.body.removeChild(sugdiv);
      }
      sugdiv = document.createElement('script');
      sugdiv.id = info.sugScriptId;
      sugdiv.src = url;
      sugdiv.charset = 'gb2312';
      document.body.appendChild(sugdiv);
    }

    sugStatus.showHistoryWord = true;
  }

  function deleteLocalStorage(name) {
    if (window.localStorage) {
      window.localStorage.removeItem(name);
    }
  }

  function clearSearchRecord() {
    if (confirm('清除全部历史查询记录？')) {
      deleteLocalStorage('v_search_record');
      getElementId('sug_wraper').style.display = 'none';
      sugStatus.showHistoryWord = false;
      return false;
    }
  }

  function bind(elem, evt, func) {
    if (elem) {
      return elem.addEventListener ? elem.addEventListener(evt, func, false) : elem.attachEvent(`on${evt}`, func);
    }
  }
  bind(document.body, 'click', (evt) => {
    const evtCpt = evt || window.event;
    let ele = evtCpt.srcElement || evtCpt.target;
    while (ele) {
      if (ele === getElementId('sug_wraper') || ele === getElementId('keyword')) {
        return;
      }
      ele = ele.parentNode;
    }
    getElementId('sug_wraper').style.display = 'none';
    sugStatus.showHistoryWord = false;
  });
  document.querySelector('input.hhy-input').addEventListener('keyup', () => {
    const { value } = document.querySelector('input.hhy-input');
    if (!value.length > 0) {
      sugStatus.showHistoryWord = false;
    }
  });
  document.querySelector('input.hhy-del').addEventListener('click', () => {
    sugStatus.showHistoryWord = false;
    document.querySelector('input.hhy-input').value = '';
    document.querySelector('.hhy-del').style.display = 'none';
    document.querySelector('input.hhy-input').focus();
  });
}());
